import { Button, Space, Switch, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import CustomSelect from '../../../utilsTsx/components/hooks/CustomSelect';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import antdMessage from '../../../utilsTsx/components/system/antdMessage';
import { columnsheadId } from '../../../utilsTsx/components/system/columnshead';

/**
 * 组件 
 * @param props 
 * @returns
 */
const SmsManage = (props: any) => {
    const apiId = 'smsManage';
    /** 可使用WebUniversal(父)组件函数 */
    const ref = useRef<any>(undefined);
    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<string>('');
    const [smsServiceData, setSmsServiceData] = useState<any>();
    const [smsSendOrReceiveData, setSmsSendOrReceiveData] = useState<any>();
    const [fetchData, setFetchData] = useState<any>();
    const [sendPageData, setSendPageData] = useState<any>();

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setDefaultService(urlService);
            setFetchData(() => ref.current.fetchData);
            setSendPageData(ref.current.sendPageData);
        }
        fetchApi.GET(urlService,
            {
                query: {
                    apiId: 'smsService',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setSmsServiceData([{ id: 'ALLITEM', serviceName: '所有短信服务' }, ...res.data]);
                }
            })
        fetchApi.GET(urlService,
            {
                query: {
                    apiId: 'generalData',
                    apiVariable: 'smsSendOrReceive',
                    apiExtend: 'showLists'
                }
            }).then(res => {
                if (res.success) {
                    const { smsSendOrReceive } = res.data;
                    setSmsSendOrReceiveData([{ id: 'ALLITEM', name: '所有短信状态' }, ...smsSendOrReceive]);
                }
            })
    }, []);

    /** 表头内容 */
    const columnsHead = [
        {
            title: '短信服务',
            dataIndex: 'smsService',
            render: (text: any) => (
                text ? text.serviceName : ''
            )
        },
        {
            title: '状态',
            dataIndex: 'smsSendOrReceive',
            render: (val: any) => val?.name
        },
        {
            title: '手机码',
            dataIndex: 'phoneNumbers',
        },
        {
            title: '内容',
            dataIndex: 'contents',
            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 8 ? text.substring(0, 8) + '......' : text)
                    : ''
            }</Tooltip>
        },
        {
            title: '成功',
            dataIndex: 'isSuccess',
            render: (text: any, record: any) => (
                <Switch checkedChildren="成功" unCheckedChildren="失败"
                    checked={text} key={record.id}
                />
            )
        },
        {
            title: '时间',
            dataIndex: 'exeDate',
            render: (val: any) =>
                <span>
                    {val ? dayjs(val).format('YYYY-MM-DD HH:mm:ss') : undefined}
                </span>,
        },
        {
            title: '信息',
            dataIndex: 'message',
            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 8 ? text.substring(0, 8) + '......' : text)
                    : ''
            }</Tooltip>
        },
        {
            title: '来源',
            dataIndex: 'comeFrom',
            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 8 ? text.substring(0, 8) + '......' : text)
                    : ''
            }</Tooltip>
        },
        {
            title: '返回码',
            dataIndex: 'returnCode',
            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 8 ? text.substring(0, 8) + '......' : text)
                    : ''
            }</Tooltip>
        },
        {
            title: '',
            dataIndex: 'id',
            render: (val: string) => (<Button type='primary' onClick={
                () => {
                    fetchApi.GET(defaultService,
                        {
                            query: {
                                apiId: 'smsManage',
                                apiExtend: 'querySendDetails',
                                apiData: {
                                    smsManageId: val
                                }
                            }
                        }).then(res => {
                            if (res.success === true) {
                                antdMessage('success', `查询成功，${JSON.stringify(res?.data)}`);
                            } else {
                                antdMessage('error', `查询失败！${res?.message}`);
                            }
                        })
                }
            }>查询</Button>)
        }
    ];

    /**
     * 表头
     */
    const columns = columnsheadId
        .concat(columnsHead as []);

    /**
     * 扩展Props
     */
    const extendProps: WebUniversalProps = {
        ...props,
        titleName: '短信管理',
        apiId,
        columns,
        serviceId: 'business',
        displayOptions: {
            showAdd: false,
            showUseBak: true,
            showOperation: false
        }
    };

    return (
        <>
            <Space>
                <CustomSelect
                    apiId={apiId}
                    sendKeyId='smsServiceId'
                    getListData={smsServiceData}
                    sendPageData={sendPageData}
                    setSendPageData={setSendPageData}
                    fetchData={fetchData}
                    itemName='serviceName'
                />
                <CustomSelect
                    apiId={apiId}
                    sendKeyId='smsSendOrReceiveId'
                    getListData={smsSendOrReceiveData}
                    sendPageData={sendPageData}
                    setSendPageData={setSendPageData}
                    fetchData={fetchData}
                />
            </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
        </>
    )
}

export default SmsManage;